if (!customElements.get('complete-the-look')) {
  class CompleteTheLook extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.productInfo = this.closest('product-info')
      this.productImage = this.querySelector('.complete-the-look__product-image img')
      this.productColor = this.querySelector('.js-complete-the-look-color')
      this.productPrice = this.querySelector('.js-complete-the-look-price')
      this.button = this.querySelector('.js-choose-btn')
      this.imageWrapper = this.querySelector('.complete-the-look__product-image')
      if (this.imageWrapper) {
        this.imageWrapper.addEventListener('click', this.openModal.bind(this))
      }
      if (this.button) {
        this.button.addEventListener('click', this.openModal.bind(this))
      }
      this.addButton = this.querySelector('.js-add-btn')
      if (this.addButton) {
        this.addButton.addEventListener('click', this.addToCart.bind(this))
      }
      this.selectedSize = this.querySelector('.js-pdp-selected-size')
      this.checkSelectedColor()
      this.checkSelectedSize()
      document.addEventListener('sizeChanged', () => this.checkSelectedSize())
      document.addEventListener('colorChanged', () => this.checkSelectedColor())
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener('click', this.openModal.bind(this))
      }
      if (this.imageWrapper) {
        this.imageWrapper.removeEventListener('click', this.openModal.bind(this))
      }
      document.removeEventListener('sizeChanged', () => this.checkSelectedSize())
      document.removeEventListener('colorChanged', () => this.checkSelectedColor())
    }

    openModal() {
      if (!this.dataset.handle) return
      openQuickAddModal(this.dataset.handle)
    }

    checkSelectedSize() {
      const selectedSize = this.productInfo.dataset.selectedSize || null
      if (selectedSize) {
        const productFound = this.jsonData.products.find(
          (product) => product.id === Number(this.dataset.productId),
        )
        if (productFound) {
          const variantFound = productFound.variants.find(
            (variant) => variant.title === selectedSize,
          )
          if (variantFound && variantFound.available) {
            this.button.classList.remove('complete-the-look__button-primary')
            this.button.classList.add('complete-the-look__button-secondary')
            this.addButton.disabled = false
            this.addButton.classList.remove('visually-hidden')
            this.selectedSize.textContent = selectedSize
            this.dataset.variantId = variantFound.id
          } else {
            this.button.classList.remove('complete-the-look__button-secondary')
            this.button.classList.add('complete-the-look__button-primary')
            this.addButton.disabled = true
            this.addButton.classList.add('visually-hidden')
            this.selectedSize.textContent = ''
            this.dataset.variantId = ''
          }
        }
      }
    }

    checkSelectedColor() {
      const selectedColor = this.productInfo.querySelector('product-colors input:checked')
      if (!selectedColor) return
      const color = selectedColor.dataset.colorList
      if (!color) return
      const productFound = this.jsonData.products.find((product) => product.color === color)
      if (!productFound) return
      if (!productFound.available) return
      this.dataset.productId = productFound.id
      this.dataset.handle = productFound.handle
      this.dataset.isClearance = productFound.is_clearance
      this.productImage.src = `${productFound.featured_image}`
      this.productImage.srcset = `${productFound.featured_image}&width=200 200w`
      this.productColor.textContent = productFound.color
      this.productPrice.innerHTML = productFound.price_html
      this.checkSelectedSize()
    }

    addToCart() {
      if (!this.dataset.variantId) return
      this.addButton.classList.add('loading')
      this.addButton.querySelector('.loading__spinner').classList.remove('hidden')
      let formData = {
        items: [
          {
            id: this.dataset.variantId,
            quantity: 1,
            ...(this.dataset.isClearance === 'false'
              ? {
                  properties: {
                    _value_builder: true,
                  },
                }
              : {}),
          },
        ],
      }
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json()
        })
        .then((data) => {
          this.addButton.classList.remove('loading')
          this.addButton.querySelector('.loading__spinner').classList.add('hidden')
          document.dispatchEvent(
            new CustomEvent('cartaddsuccess', {
              detail: { openCart: true, refreshCart: true },
            }),
          )
        })
        .catch((error) => {
          console.error(error)
          this.addButton.classList.remove('loading')
          this.addButton.querySelector('.loading__spinner').classList.add('hidden')
        })
    }

    get jsonData() {
      const jsonDataContext = this.querySelector('.complete-the-look-context-json')
      if (!jsonDataContext) return null
      return JSON.parse(jsonDataContext.textContent)
    }
  }
  customElements.define('complete-the-look', CompleteTheLook)
}
